module.exports = __webpack_public_path__ + "static/media/fire.ccfd745f.svg";